import React from 'react';
import styled from 'styled-components';

import { InternalLink, ExternalLink } from '../ui-components';

import { isInternalLink } from '../utils/link-handler';

/**
 * Renders a CTA section to embed inside insights
 *
 * @component InsightCTA
 * 
 * @param {object} props
 * 
 * @prop {string} caption
 * @prop {string} buttonText
 * @prop {string} buttonUrl 
 * 
 * @return {JSX}
 */
const InsightCTA = props => {
  const { caption, buttonText, buttonUrl } = props;

  return (
    <>
      <CtaHr />
      <CtaHeader>{caption}</CtaHeader>
      <CtaButtonContainer>

      {isInternalLink(buttonUrl) ?
            <InternalLink linkstyle={'secondary-button'} to={buttonUrl}>
              {buttonText}
            </InternalLink>
            :
            <ExternalLink linkstyle={'secondary-button'} href={buttonUrl}>
              {buttonText}
            </ExternalLink>
          }
          </CtaButtonContainer>
      <CtaHr />
    </>
  );
};

const CtaHr = styled.hr`
  height: 1px;
  margin-bottom: 25px;
`

const CtaHeader = styled.h5`
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 25px;
`;

const CtaButtonContainer = styled.div`
  margin-left: 15px;
  margin-bottom: 25px;
`

export default InsightCTA;
